// Zona del visor del documento visible en pantalla, para recortar las capas fijas (portal a <body>) que se
// dibujan sobre las hojas en mobile: el área con scroll propio donde está la hoja, sin el panel inferior de
// /sign ni su tirador (40 px arriba), que van por encima del visor. Devuelve null si no se puede medir.
export const getViewerClip = (pageEl) => {
  let clip = null;
  for (let n = pageEl?.parentElement; n && n !== document.body; n = n.parentElement) {
    const oy = window.getComputedStyle(n).overflowY;
    if (oy === 'auto' || oy === 'scroll') {
      const c = n.getBoundingClientRect();
      clip = { left: c.left, top: c.top, right: c.right, bottom: c.bottom };
      break;
    }
  }
  if (!clip) return null;
  const sheet = document.querySelector('[data-bottom-sheet="true"]');
  if (sheet) clip.bottom = Math.min(clip.bottom, sheet.getBoundingClientRect().top - 40);
  return clip;
};
